import React, { useEffect, useState } from "react";
import Sidebar from "../includes/Sidebar";
import MainHeading from "../includes/MainHeading";
import Footer from "../includes/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminListService from "../../../services/admin-list.service";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import ReactLoading from "react-loading";
import { updateGift } from "../../../schema";

export default function EditGift() {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  const state = useSelector((state) => state.stateVals);
  const { adminAccessToken, admin_id } = state;
  const navigate = useNavigate();
  const [file, setFile] = useState("");

  useEffect(() => {
    if (adminAccessToken) {
      const getSingleGift = async () => {
        setLoading(true);
        try {
          const response = await AdminListService.getGiftById(id);

          setValues({
            title: response.data.response.name,
            description: response.data.response.description,
            image: response.data.response.image,
            points: response.data.response.points,
            type:
              response.data.response.bb_price && response.data.response.sku
                ? "bestbuy"
                : "local",
            bb_price: response.data.response.bb_price || "",
            sku: response.data.response.sku || "",
          });
          setLoading(false);
        } catch (err) {
          console.log(err);
          setLoading(false);

          if (
            err?.response?.data?.message &&
            typeof err?.response?.data?.message === "string"
          ) {
            toast.error(err?.response?.data?.message, {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            toast.error("Something went wrong, try again", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      };
      getSingleGift();
    } else {
      navigate("/admin/login", { replace: true });
    }
    // eslint-disable-next-line
  }, []);

  const handleFileChange = async (e) => {
    setFile(e.target.files[0]);
  };

  const updateGiftFun = async (values) => {
    const formData = new FormData();
    if (file !== "") {
      formData.append("image", file);
    }

    formData.append("adminId", parseInt(admin_id));
    formData.append("points", values.points);
    formData.append("name", values.title);
    formData.append("description", values.description);
    formData.append("type", values.type);
    if (values.type === "bestbuy") {
      formData.append("bb_price", values.bb_price);
      formData.append("sku", values.sku);
    } else {
      formData.append("bb_price", "");
      formData.append("sku", "");
    }
    setLoading(true);
    try {
      const response = await AdminListService.updateGiftById(formData, id);

      toast.success(response?.data?.response, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setLoading(false);
      setTimeout(() => {
        navigate("/admin/manage-products", { replace: true });
      }, 1000);
    } catch (err) {
      console.log(err);
      setLoading(false);

      if (
        err?.response?.data?.response &&
        typeof err?.response?.data?.response === "string"
      ) {
        toast.error(err?.response?.data?.response, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.image?.length) {
        toast.error(err?.response?.data?.image[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.model_no?.length) {
        toast.error(err?.response?.data?.model_no[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.item_no?.length) {
        toast.error(err?.response?.data?.item_no[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.name?.length) {
        toast.error(err?.response?.data?.name[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.description?.length) {
        toast.error(err?.response?.data?.description[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.error("Something went wrong, try again", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const {
    values,
    errors,
    touched,
    setValues,
    setFieldValue,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      title: "",
      description: "",
      image: "",
      points: "",
      type: "local",
      bb_price: "",
      sku: "",
    },
    validationSchema: updateGift,
    onSubmit: (values) => {
      updateGiftFun(values);
    },
  });

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <Sidebar />
          <MainHeading heading="Update Product" />

          <div className="mt-4 row">
            <div className="col-md-12 col-12">
              <div className="card dashboard-cards">
                <div className="bg-white  py-3 card-header">
                  <h4 className="mb-0">Update Product </h4>
                </div>
                <div className="card-body">
                  <form className="row" onSubmit={handleSubmit} noValidate>
                    <div className="col-md-6">
                      <div className="input-field-box">
                        <label>
                          Product Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Product Name"
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue("description", e.target.value);
                          }}
                          name="title"
                          value={values.title || ""}
                        />
                        {errors.title && touched.title ? (
                          <span className="text-danger">{errors.title}</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-field-box">
                        <label>
                          Points <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Points"
                          onChange={handleChange}
                          name="points"
                          value={values.points || ""}
                        />
                        {errors.points && touched.points ? (
                          <span className="text-danger">{errors.points}</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-field-box">
                        <label>
                          Description <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Description"
                          onChange={handleChange}
                          name="description"
                          value={values.description || ""}
                        />
                        {errors.description && touched.description ? (
                          <span className="text-danger">
                            {errors.description}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input-field-box">
                        <label>Product Type</label>
                        {/* <select
                          className="form-select"
                          disabled={true}
                          name="type"
                          value={values.type || ""}
                        >
                          <option value="local">Local</option>
                          <option value="bestbuy">BestBuy</option>
                        </select> */}
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Type"
                          disabled={true}
                          value={values.type || ""}
                        />
                      </div>
                    </div>
                    {values.type === "bestbuy" && (
                      <>
                        <div className="col-md-4">
                          <div className="input-field-box">
                            <label>
                              BestBuy Price{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Price"
                              disabled={true}
                              name="bb_price"
                              value={values.bb_price || ""}
                              min={0}
                            />
                            {errors.bb_price && touched.bb_price ? (
                              <span className="text-danger">
                                {errors.bb_price}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-field-box">
                            <label>
                              SKU <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="SKU"
                              onChange={handleChange}
                              name="sku"
                              value={values.sku || ""}
                              min={0}
                            />
                            {errors.sku && touched.sku ? (
                              <span className="text-danger">{errors.sku}</span>
                            ) : null}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-md-10">
                      <div className=" file-area">
                        <input
                          type="file"
                          name="images"
                          id="images"
                          required="required"
                          accept=".png,.jpg,.jpeg,.webp"
                          onChange={handleFileChange}
                        />
                        <div className="file-dummy">
                          <div className="success">
                            Great, your image is selected. Keep on.
                          </div>
                          <div className="default">Choose Image</div>
                        </div>
                      </div>
                      {errors.image && touched.image ? (
                        <span className="text-danger">{errors.image}</span>
                      ) : null}
                    </div>
                    <div className="col-md-2 text-center">
                      <img
                        src={`${process.env.REACT_APP_IMAGE_Link}${values.image}`}
                        alt=""
                        className="img-fluid edit-gift-img"
                      />
                    </div>

                    <div className="col-12">
                      <button className="btn btn-primary mt-3" type="submit">
                        Update Product
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      {loading && (
        <ReactLoading
          type="spinningBubbles"
          color="#185791"
          className="bar-loader"
        />
      )}
    </div>
  );
}
